<template>
    <div class="coupon" v-if="is_body_show">
        <div class="coupon-li" >
            <div class="train-title" style="padding: 12px 12px 0 12px">
                <img :src="util.G_CONFIG.logo" v-if="util.G_CONFIG.logo != ''" style="width: 18px;vertical-align: middle;margin-right: 5px">
                <span v-if="util.G_CONFIG.train_name != ''" style="font-size: 12px;color: #999">{{util.G_CONFIG.train_name}}</span>
            </div>
            <div class="coupon-content">
                <div class="coupon-type">
                    <span v-if="item.coupon_type == 1">抵扣券</span>
                    <span v-if="item.coupon_type == 2">折扣券</span>
                </div>
                <div class="coupon-money">
                    <span>{{item.coupon_name}}</span>

                    <div style="color: #327CE9;float: right">
                        <span v-if="item.coupon_type == 1"><span class="coupon-money-txt">{{item.money * 1 }}</span>元</span>
                        <span v-if="item.coupon_type == 2"><span class="coupon-money-txt">{{item.discount * 1 }}</span>折</span>
                    </div>
                </div>
                <div class="coupon-txt">
                    <span v-if="item.coupon_type == 1 && item.full_money*1>0">
                        满{{item.full_money * 1 }}元减{{item.money * 1}}元
                    </span>
                    <span v-if="item.coupon_type == 2 && item.full_money*1>0">
                        满{{item.full_money * 1 }}元打{{item.discount * 1}}折
                    </span>
                    <span v-if="item.full_money*1 == 0">无门槛使用</span>
                </div>
            </div>
            <div class="coupon-btn">
                <div class="coupon-time">
                    <span>
                        此券有效期至{{item.use_time_end_date}}
                    </span>
                </div>
                <div class="coupon-receive-btn">
                    <div class="coupon-receive color-FF5C4A" @click="bindReceiveCoupon(item.coupon_id)">
                        <span>{{(item.receive*1) == 0?'立即':'继续'}}领取</span>
                    </div>
                    <div class="coupon-receive color-327CE9" @click="bindGoCouponCourse(item, item.coupon_id)" v-if="(item.receive*1) > 0">
                        <span>立即使用</span>
                    </div>
                </div>
            </div>

            <div class="coupon-received" v-if="(item.receive*1) > 0">
                已领取
            </div>
        </div>
        <div style="padding: 10px">
            <van-button type="info" :to='{path:"/train/h5/home/index",query:{token:util.token}}' block>返回首页</van-button>
        </div>
    </div>
</template>

<script>
    import { List ,Button} from 'vant';
    export default {
        name: "detail",
        components:{
            [List.name]:List,
            [Button .name]:Button,
        },
        data(){
            return {
                is_body_show: false,
                coupon_id:"",
                item:{
                    "coupon_id":"56eafee5a7cb671b4c4db814d332795e",
                    "coupon_name":"测试",
                    "train_id":"196",
                    "money":"10.00",
                    "time_start":"1608962880",
                    "time_end":"1609222080",
                    "sum_number":"3",
                    "use_number":null,
                    "quota_number":"1",
                    "quota_day":"0",
                    "remarks":null,
                    "is_delete":"0",
                    "create_by":"16",
                    "create_time":"1608962806",
                    "modify_by":"16",
                    "modify_time":"1608963140",
                    "coupon_type":"1",
                    "discount":null,
                    "full_money":"0.00",
                    "use_time_start":"1608962880",
                    "use_time_end":"1609308480",
                    "change_course":"1",
                    "change_user":"0",
                    "change_course_list":",147,146,169,177,178,179,180,181,212,213,214,233",
                    "change_user_list":"",
                    "status":null,
                    "receive":"0",
                    "use_time_start_date":"2020-12-26 02:08",
                    "use_time_end_date":"2020-12-30 02:08"
                }
            }
        },
        mounted() {
            this.coupon_id = this.util.getQueryStr('coupon_id');
            this.getCouponDetail();
            this.bindWeiXin();
        },
        methods:{
            bindReceiveCoupon(coupon_id){
                var _self=this;

                this.util.server.mini_coupon.receive_coupon({
                    data:{
                        coupon_id:coupon_id
                    },
                    callback: (res => {
                        
                        if(res.code == 1){
                            this.util.showToast({
                                message: res.msg
                            });
                            this.item.receive = this.item.receive*1+1;
                        }else{
                            this.util.showToast({
                                message: res.msg
                            });
                        }
                    })
                })
            },
            bindGoCouponCourse(item, coupon_id){
                if(item.change_course==1){ //跳课程
                    var str = item.change_course_list.replace(/^,+/,"").replace(/,+$/,"");
                    var arr = str.split(',')
                    if(arr && arr.length==1){
                        //直接跳课程
                        this.$router.push(this.util.urlPrefix+'/curriculum/index?course_id='+arr[0]+'&token='+this.util.token)
                    }else{
                        //跳课程列表
                        this.$router.push(this.util.urlPrefix+'/coupon/coupon_course?coupon_id='+coupon_id+'&token='+this.util.token)
                    }
                }else if(item.change_training==1){ //跳训练营
                    var str = item.change_training_list.replace(/^,+/,"").replace(/,+$/,"");
                    var arr = str.split(',')
                    if(arr.length==1 && 0){
                        //直接跳营期
                        this.$router.push(this.util.urlPrefix+'/training/index?train_id='+arr[0]+'&token='+this.util.token)
                    }else{
                        //跳营期列表
                        this.$router.push(this.util.urlPrefix+'/coupon/coupon_training?coupon_id='+coupon_id+'&token='+this.util.token)
                    }
                }else{ //跳所有
                    this.$router.push(this.util.urlPrefix+'/coupon/coupon_list?coupon_id='+coupon_id+'&token='+this.util.token)
                }
                
            },
            bindWeiXin(){
                var _self=this;
                this.util.jweixin(function (wx) {
                    var _that=_self;
                    _self.util.wxShare(wx, {
                        title: _that.module_name,
                        desc: _that.module_name,
                        link: location.href,
                        imgUrl: this.util.G_CONFIG.logo
                    });
                });
            },
            getCouponDetail(){
                const _self = this
                this.util.server.mini_coupon.detail({
                    data:{
                        coupon_id:this.coupon_id,
                    },
                    methods:'get',
                    callback: (res => {
                        const { code, data, msg } = res;
                        _self.is_body_show = true
                        if(code == 1) {
                            _self.item = data
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            }
        }
    }
</script>

<style scoped>
    .color-FF5C4A{
        color: #FF5C4A;
    }
    .color-327CE9{
        color: #327CE9;
    }
    div{
        /* color: #3a3a3a; */
    }
    .coupon-received{
        position: absolute;
        left: 50%;
        top: 50%;
        color: #FF5C4A;
        font-size: 25px;
        transform: rotate(-28deg);
        opacity: .5;
        margin-left: -30px;
        margin-top: -17px;
    }
    .coupon-surplus{
        font-size: 12px;
        font-weight: 500;
        padding: 2px 5px;
        background-color: #ff847c;
        color: #fff;
        border-radius: 10px;
        margin-left: 5px;
    }
    .coupon-li{
        margin: 10px;
        position: relative;
        background-color: #fff;
        border-radius: 5px;
        overflow: hidden;
    }
    .coupon-content{
        padding: 10px 20px;
    }
    .coupon-type{
        position: absolute;
        right: 0;
        top: 0;
        font-size: 10px;
        padding: 2px 5px;
        background-color: #FF5C4A;
        color: #fff;
        border-radius:4px 4px 4px 0;
    }
    .coupon-money{
        font-weight: bold;
        font-size: 16px;
    }
    .coupon-money-txt{
        font-size: 30px;
        color: #327CE9;
        margin-right: 2px;
    }
    .coupon-txt{
        font-size: 12px;
        margin-top: 5px;
        color: #999;
    }
    .coupon-btn{
        position: relative;
        padding: 25px 20px;
        padding-right: 80px;
        background-image: linear-gradient(to right, #eee 0%, #eee 50%, transparent 50%);
        background-size: 28px 1px;
        background-repeat: repeat-x;
    }
    .coupon-btn::after,.coupon-btn::before{
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        background-color: #f8f8f8;
        border-radius: 10px;
    }
    .coupon-btn::after{
        top: -10px;
        right: -10px;
    }
    .coupon-btn::before{
        top: -10px;
        left: -10px;
    }
    .coupon-time{
        display: inline-block;
        font-size: 12px;
        color: #999999;
    }
    .coupon-receive{
        font-size: 12px;
    }
    .coupon-receive-btn{
        position: absolute;
        right: 10px;
        top: 0;
        width: 58px;
        height: 100%;
        /*flex 布局*/
        display: flex;
        flex-wrap: wrap;
        /*实现垂直居中*/
        align-items: center;
        /*实现水平居中*/
        justify-content: center;
    }
</style>
